import React from "react";

const CheckPoint = ({
    title,
    description
}: {
    title?: string;
    description: string;
}) => (
    <div className="flex items-start">
        <div className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-brand text-gray-100 md:h-10 md:w-10">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-4 w-4 md:h-5 md:w-5"
                aria-hidden="true"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                />
            </svg>
        </div>

        <div className="ml-4">
            {title && (
                <h4 className="text-h3 font-bold dark:text-gray-50">{title}</h4>
            )}
            <p
                className={`text-body dark:text-gray-400 ${title ? "mt-2" : ""}`}
            >
                {description}
            </p>
        </div>
    </div>
);

export default CheckPoint;
